var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shop-detail',
  created () {
    this.search()
  },
  data () {
    return {
      mapLat: null,
      mapLng: null,
      mapZoom: null,
    }
  },
  computed: {
    shop () {
      return this.$store.getters.shopDetail
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    postFirst () {
      return this.shop.attributes['shop-post-no'] ? this.shop.attributes['shop-post-no'].substring(0, 3) : ''
    },
    postLast () {
      return this.shop.attributes['shop-post-no'] ? this.shop.attributes['shop-post-no'].substring(3, 7) : ''
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goUserLists: function () {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goShops: function () {
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopNew: function () {
      this.$router.push({ path: '/shops/new', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopEdit: function (shopId) {
      this.$router.push({ path: '/shops/' + shopId + '/edit'})
    },
    search: function() {
      var self = this
      var data = {}
      var callback = function() {
        self.mapLat = self.shop.attributes['shop-map-lat']
        self.mapLng = self.shop.attributes['shop-map-lng']
        self.mapZoom = self.shop.attributes['shop-map-zoom']
        setTimeout(() => {
          self.initMap()
        }, 100)
      }
      this.$store.dispatch('SHOP_DETAIL', { id: this.$route.params.id, data: data, callback: callback })
    },
    shopDelete: function(shopId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('SHOP_DELETE',  {id: shopId, callback: this.onSaved })
      }
    },
    onSaved: function (result) {
      this.$router.push('/shops')
    },
    initMap: function () {
      var self = this
      var mapDiv = document.getElementById('map')
      var latlng = new google.maps.LatLng(self.mapLat,self.mapLng)
      self.map = new google.maps.Map(mapDiv, {
        zoom: self.mapZoom,
        center: latlng,
        scrollwheel: false
      })
      var marker = new google.maps.Marker({
        position: latlng
      })
      marker.setMap(self.map);
    },
    goShopUserList: function (shopId) {
      this.$router.push({ path: '/shops/' + shopId + '/users',  query: { type: this.$router.currentRoute.query.type }})
    },
    telChange: function (tel) {
      return 'tel:' + tel
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-detail.js